import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { getPasswordChecks } from "@/lib/validation";

const fieldClass =
  "w-full h-10 pl-3 pr-3 text-sm bg-white border border-zinc-200 rounded-sm focus:ring-1 focus:ring-zinc-900 focus:border-zinc-900 outline-none";

export function Input({
  label, value, onChange, type = "text", testId, icon: Icon, inputMode, autoComplete, maxLength,
  inputClassName = "", error, onBlur,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  return (
    <div>
      <label className="block text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-700 mb-1.5">{label}</label>
      <div className="relative">
        {Icon && <Icon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />}
        <input
          type={inputType}
          required
          inputMode={inputMode}
          autoComplete={autoComplete}
          maxLength={maxLength}
          data-testid={testId}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          aria-invalid={error ? true : undefined}
          className={`${fieldClass} ${Icon ? "pl-9" : ""} ${isPassword ? "pr-9" : ""} ${inputClassName} ${
            error ? "border-rose-300 focus:border-rose-500 focus:ring-rose-500" : ""
          }`}
        />
        {isPassword && (
          <button
            type="button"
            tabIndex={-1}
            aria-label={showPassword ? "Hide password" : "Show password"}
            data-testid={testId ? `${testId}-toggle` : undefined}
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-700"
          >
            {showPassword ? <EyeSlash size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
      {error && (
        <p className="mt-1 text-xs text-rose-600" role="alert" data-testid={testId ? `${testId}-error` : undefined}>
          {error}
        </p>
      )}
    </div>
  );
}

export function PasswordRequirements({ password }) {
  const checks = getPasswordChecks(password);
  return (
    <ul className="mt-1.5 space-y-0.5" data-testid="password-requirements">
      {checks.map((c) => (
        <li
          key={c.key}
          className={`text-xs ${c.ok ? "text-emerald-700" : "text-zinc-500"}`}
        >
          {c.ok ? "✓" : "○"} {c.label}
        </li>
      ))}
    </ul>
  );
}
